
import axios from '@axios'

export default {
    namespaced: true,
    state: {
        datosGenerales: [],
        rendicanal: [],
        datosClientes:[],
        datosCanal:[],
        rendiAuto: [],
        proyecciones: [],
    },
    getters: {
        getDatosGenerales(state) {
            return state.datosGenerales
        },
        getDatosClientes(state) {
            return state.datosClientes
        },
        getRendimientoCanal(state) {
            return state.rendicanal
        },
        getRendimientoAuto(state) {
            return state.rendiAuto
        },
        getDatosCanal(state){
            return state.datosCanal
        },
        getProyecciones(state){
            return state.proyecciones
        },

    },
    mutations: {
        setdatosGenerales(state, datosGenerales) {
            state.datosGenerales = datosGenerales
        },
        setRendimientoCanal(state, rendicanal) {
            state.rendicanal = rendicanal
        },
        setdatosClientes(state, datosClientes) {
            state.datosClientes = datosClientes
        },
       
        setRendimientoAuto(state, rendiAuto) {
            state.rendiAuto = rendiAuto
        },
        setdatosItems(state,datosItems){
            state.datosItems = datosItems
        },
        setdatosCanal(state,datosCanal){
            state.datosCanal = datosCanal
        },
        setProyecciones(state, proyecciones){
            state.proyecciones = proyecciones
        },

    },
    actions: {
        fetchDatosGenerales({ commit }, data) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/ventasNacionales/resumen`
                axios.post(url, data)
                    .then((response) => {
                        commit('setdatosGenerales', response.data)
                        resolve(response)

                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        fetchDatosClientes({ commit }, data){
            return new Promise((resolve, reject) => {
                var url = `/api/auth/ventasNacionales/detallesClientes`
                axios.post(url, data)
                    .then((response) => {
                        commit('setdatosClientes', response.data)
                        resolve(response)

                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
     
        fetchRendimientoCanal({ commit }, data) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/ventasNacionales/rendimientoCanal`
                axios.post(url, data)
                    .then((response) => {
                        commit('setRendimientoCanal', response.data)
                        resolve(response)

                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        

        fetchRendimientoAuto({ commit }, data) {
            return new Promise((resolve, reject) => {
                var url = `/api/auth/ventasNacionales/rendimientoAuto`
                axios.post(url, data)
                    .then((response) => {
                        commit('setRendimientoAuto', response.data)
                        resolve(response)

                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchDatosCanal({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventasNacionales/ventasCanal', { params: data })
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },

        fetchProyecciones({ commit }, data){
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/ventas/proyeccionesIPSP', { params: data})
                    .then((response) => {
                        commit('setProyecciones', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
    },
}